import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  key: 0,
  src: "",
  alt: "Airline Logo",
  class: "airline-logo_img"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "login-label" }, [
  /*#__PURE__*/_createElementVNode("p", null, "LOGIN")
], -1)
const _hoisted_4 = { class: "btn-confirm" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SFSInput = _resolveComponent("SFSInput")!
  const _component_StyledLogin = _resolveComponent("StyledLogin")!

  return (_openBlock(), _createBlock(_component_StyledLogin, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          (_ctx.airlineLogo)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _hoisted_3,
        _createVNode(_component_SFSInput, {
          modelValue: _ctx.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          label: "Username",
          type: "text",
          placeholder: "Username"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_SFSInput, {
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          label: "Password",
          type: "password",
          placeholder: "Password"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            disabled: _ctx.disabled,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
          }, "Login", 8, _hoisted_5)
        ])
      ])
    ]),
    _: 1
  }))
}